import { createReducer, createActions } from 'reduxsauce'
import roundCredits from 'utils/roundCredits'

// Initial State
export const initialState = {
    isAMToolActive: false,
    credits: 0,
    selection: {}
}

// Types and Action Creators
const { Types, Creators } = createActions(
    {
        clean: null,
        toogleAMTool: null,
        setCredits: ['credits'],
        cleanSelection: null,
        updatePreSeasonSelection: ['groupId', 'typeId', 'units'],
        updatePreRaceSelection: ['groupId', 'value'],
        updatePostRaceSelection: ['groupId', 'value'],
        // Sagas
        endPhase: null
    },
    {
        prefix: 'PHASE_'
    }
)

export const PhaseTypes = Types

// Reducers and Handlers
export const handlers = {
    [Types.CLEAN]: () => ({ ...initialState }),
    [Types.TOOGLE_A_M_TOOL]: (state = initialState) => ({ ...state, isAMToolActive: !state.isAMToolActive }),
    [Types.SET_CREDITS]: (state = initialState, { credits }) => ({ ...state, credits: roundCredits(credits) }),
    [Types.CLEAN_SELECTION]: (state = initialState) => ({ ...state, selection: initialState.selection }),
    [Types.UPDATE_PRE_SEASON_SELECTION]: (state = initialState, { groupId, typeId, units }) => ({
        ...state,
        selection: {
            ...state.selection,
            [groupId]: {
                type: typeId,
                units: typeof units === 'number' ? units : (state.selection[groupId] || {}).units || 0
            }
        }
    }),
    [Types.UPDATE_PRE_RACE_SELECTION]: (state = initialState, { groupId, value }) => ({
        ...state,
        selection: {
            ...state.selection,
            [groupId]: value
        }
    }),
    [Types.UPDATE_POST_RACE_SELECTION]: (state = initialState, { groupId, value }) => ({
        ...state,
        selection: {
            ...state.selection,
            [groupId]: value
        }
    })
}

export const reducer = createReducer(initialState, handlers)

export default Creators



// WEBPACK FOOTER //
// src/store/redux/phase.js